export default __webpack_public_path__ + "static/media/sauna.160fa5bf.svg";